/* Keep product hero on the first image – ignore variant media */

document.addEventListener('DOMContentLoaded', function () {
  function keepFirstImage() {
    // Try to find the main media list / gallery
    var gallery =
      document.querySelector('[data-product-media]') ||
      document.querySelector('.product__media-list') ||
      document.querySelector('.product__media');

    if (!gallery) return;

    // Grab all media items (Shrine / OS 2.0 style)
    var items =
      gallery.querySelectorAll('[data-media-id]') ||
      gallery.querySelectorAll('.product__media-item');

    if (!items || !items.length) return;

    items.forEach(function (el, index) {
      // Force the FIRST image to be the only "active" one
      if (index === 0) {
        el.classList.add('is-active');
        el.removeAttribute('hidden');
        el.style.opacity = '1';
      } else {
        el.classList.remove('is-active');
        // Do NOT hide them completely so the slider still works if needed
      }
    });
  }

  // Helper: run after a tiny delay so Shrine finishes its own updates first
  function resetAfterVariantChange(evt) {
    if (evt && evt.detail && evt.detail.variant) {
      // If Shrine uses featured_media, wipe it out
      if (evt.detail.variant.featured_media) {
        evt.detail.variant.featured_media = null;
      }
    }
    setTimeout(keepFirstImage, 10);
  }

  // Listen for several common variant events
  ['variant:change', 'variantChange', 'product:variant-change'].forEach(function (evtName) {
    document.addEventListener(evtName, resetAfterVariantChange);
  });

  // Fallback: any change on option inputs will trigger a reset
  document.addEventListener('change', function (e) {
    if (
      e.target.matches('select[name^="options["], input[name^="options["]') ||
      e.target.closest('form[action*="/cart/add"]')
    ) {
      setTimeout(keepFirstImage, 10);
    }
  });
});